module.exports = __webpack_public_path__ + "img/chest-ectomorph-male.186a0a2b.svg";